import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';

interface IProps {
  items: {
    name: string;
    description: string;
  }[];
}

export const FileList = observer(
  (props: IProps): ReactElement => (
    <>
      {props.items.length > 0 && (
        <ul className='file-list'>
          {props.items.map((f, i) => (
            <li
              className='file-list-item'
              key={i}
            >
              {f.name} ({f.description})
            </li>
          ))}
        </ul>
      )}
    </>
  )
);
